(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function() {
    function refreshCartDrawer(cartData) {
      fetch('/?sections=cart-drawer-section', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var html = data['cart-drawer-section'] || '';
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newInner = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
          var oldInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
          if (newInner && oldInner) {
            oldInner.className = newInner.className;
            oldInner.innerHTML = newInner.innerHTML;
          }
          if (cartData && cartData.item_count !== undefined) {
            var badges = document.querySelectorAll('[data-cart-count]');
            badges.forEach(function(b) {
              b.textContent = cartData.item_count;
              b.style.display = cartData.item_count > 0 ? 'flex' : 'none';
            });
          }
        })
        .catch(function(err) { console.error('Cart refresh error:', err); });
    }

    // Remove item via AJAX + refresh drawer via Section Rendering API
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.eldaly-cart-item__remove');
      if (!btn || btn.classList.contains('is-removing')) return;
      e.preventDefault();
      e.stopPropagation();

      var line = parseInt(btn.getAttribute('data-line'));
      btn.classList.add('is-removing');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
        .then(function(resp) { return resp.json(); })
        .then(function(cart) {
          refreshCartDrawer(cart);
        })
        .catch(function(err) {
          console.error('Cart remove error:', err);
          btn.classList.remove('is-removing');
        });
    });

    // Quantity increment / decrement via AJAX
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.eldaly-cart-item__qty-btn');
      if (!btn || btn.classList.contains('is-disabled')) return;
      e.preventDefault();
      e.stopPropagation();

      var qtyWrap = btn.closest('.eldaly-cart-item__qty');
      if (!qtyWrap || qtyWrap.classList.contains('is-updating')) return;
      var line = parseInt(qtyWrap.getAttribute('data-line'));
      var currentQty = parseInt(qtyWrap.getAttribute('data-qty'));
      var action = btn.getAttribute('data-action');
      var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);

      qtyWrap.classList.add('is-updating');
      var valEl = qtyWrap.querySelector('.eldaly-cart-item__qty-val');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: line, quantity: newQty })
      })
        .then(function(resp) { return resp.json(); })
        .then(function(cart) {
          qtyWrap.classList.remove('is-updating');
          refreshCartDrawer(cart);
        })
        .catch(function(err) {
          console.error('Cart quantity error:', err);
          qtyWrap.classList.remove('is-updating');
          if (valEl) valEl.textContent = currentQty;
        });
    });

    // Listen for cart add/update events (shopify:cart:lines-update is the standard event name)
    document.addEventListener('shopify:cart:lines-update', function(event) {
      if (event.action === 'add') {
        var p = event.promise;
        if (p && p.then) {
          p.then(function(res) {
            refreshCartDrawer(res && res.cart ? res.cart : null);
          }).catch(function() {});
        } else {
          refreshCartDrawer();
        }
      }
    });

    // Init: hide cart count badge if 0
    document.querySelectorAll('[data-cart-count]').forEach(function(b) {
      var count = parseInt(b.textContent.trim(), 10) || 0;
      b.style.display = count > 0 ? 'flex' : 'none';
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.getElementById('search-modal');
    if (!modal) return;
    var dialog = modal.querySelector('.eldaly-search-dialog');
    var input = modal.querySelector('[data-eldaly-search-input]');
    var iconBox = modal.querySelector('[data-eldaly-search-icon]');
    var spinner = modal.querySelector('[data-eldaly-search-spinner]');
    var resultsBox = modal.querySelector('[data-eldaly-results]');
    var grid = modal.querySelector('[data-eldaly-grid]');
    var countEl = modal.querySelector('[data-eldaly-count]');
    var noResults = modal.querySelector('[data-eldaly-noresults]');
    var noResultsText = modal.querySelector('[data-eldaly-noresults-text]');
    var showAll = modal.querySelector('[data-eldaly-showall]');
    var showAllLink = modal.querySelector('[data-eldaly-showall-link]');

    var debounceTimer = null;
    var currentRequest = null;
    var currentTerm = '';

    function escapeHtml(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function reset() {
      if (input) input.value = '';
      currentTerm = '';
      if (grid) grid.innerHTML = '';
      if (countEl) { countEl.hidden = true; countEl.textContent = ''; }
      if (noResults) noResults.hidden = true;
      if (showAll) showAll.hidden = true;
      if (resultsBox) resultsBox.scrollTop = 0;
      setLoading(false);
    }

    function setLoading(loading) {
      if (iconBox) iconBox.hidden = loading;
      if (spinner) spinner.hidden = !loading;
    }

    function renderResults(products, term) {
      if (!grid) return;
      grid.innerHTML = '';
      if (!products || !products.length) {
        if (countEl) { countEl.hidden = true; }
        if (noResults) {
          noResults.hidden = false;
          if (noResultsText) noResultsText.textContent = 'No results found for \u201C' + term + '\u201D';
        }
        if (showAll) showAll.hidden = true;
        return;
      }
      if (noResults) noResults.hidden = true;

      if (countEl) {
        countEl.hidden = false;
        countEl.textContent = products.length + ' result' + (products.length !== 1 ? 's' : '') + ' for \u201C' + term + '\u201D';
      }

      var frag = document.createDocumentFragment();
      for (var i = 0; i < products.length; i++) {
        var p = products[i];
        var a = document.createElement('a');
        a.className = 'eldaly-search-result';
        a.href = p.url;
        a.setAttribute('role', 'listitem');

        var imgWrap = document.createElement('div');
        imgWrap.className = 'eldaly-search-result__img';
        var imgSrc = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
        if (imgSrc) {
          var img = document.createElement('img');
          img.src = imgSrc;
          img.alt = p.title || '';
          img.loading = 'lazy';
          img.className = 'eldaly-search-result__img-el';
          imgWrap.appendChild(img);
        } else {
          var fb = document.createElement('div');
          fb.className = 'eldaly-search-result__img-fallback';
          fb.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
          imgWrap.appendChild(fb);
        }

        var text = document.createElement('div');
        text.className = 'eldaly-search-result__text';
        var title = document.createElement('span');
        title.className = 'eldaly-search-result__title';
        title.textContent = p.title || '';
        text.appendChild(title);
        var brand = (p.vendor || '').trim();
        if (brand) {
          var brandEl = document.createElement('span');
          brandEl.className = 'eldaly-search-result__brand';
          brandEl.textContent = brand;
          text.appendChild(brandEl);
        }

        a.appendChild(imgWrap);
        a.appendChild(text);
        frag.appendChild(a);
      }
      grid.appendChild(frag);

      // "Show All Results" — link to the full search page.
      if (showAll && showAllLink) {
        showAll.hidden = false;
        showAllLink.href = '/search?q=' + encodeURIComponent(term.trim()) + '&type=product';
        showAllLink.textContent = 'Show All Results';
      }
    }

    function performSearch(term) {
      var trimmed = (term || '').trim();
      if (!trimmed) {
        if (grid) grid.innerHTML = '';
        if (countEl) { countEl.hidden = true; }
        if (noResults) noResults.hidden = true;
        if (showAll) showAll.hidden = true;
        setLoading(false);
        return;
      }
      setLoading(true);
      if (currentRequest) { try { currentRequest.abort(); } catch (e) {} }
      var url = '/search/suggest.json?q=' + encodeURIComponent(trimmed) +
        '&resources%5Btype%5D=product&resources%5Blimit%5D=10';
      var xhr = new XMLHttpRequest();
      currentRequest = xhr;
      xhr.open('GET', url, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function () {
        if (xhr !== currentRequest) return;
        currentRequest = null;
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var data = JSON.parse(xhr.responseText);
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(products, trimmed);
          } catch (e) {
            renderResults([], trimmed);
          }
        } else {
          renderResults([], trimmed);
        }
        setLoading(false);
      };
      xhr.onerror = function () {
        if (xhr !== currentRequest) return;
        currentRequest = null;
        setLoading(false);
      };
      xhr.send();
    }

    function onInput() {
      var val = input ? input.value : '';
      var trimmed = val.trim();
      if (debounceTimer) clearTimeout(debounceTimer);
      if (!trimmed) {
        currentTerm = '';
        if (grid) grid.innerHTML = '';
        if (countEl) { countEl.hidden = true; }
        if (noResults) noResults.hidden = true;
        if (showAll) showAll.hidden = true;
        setLoading(false);
        return;
      }
      debounceTimer = setTimeout(function () { performSearch(trimmed); }, 300);
    }

    if (input) input.addEventListener('input', onInput);

    // Focus the input shortly after the dialog opens (mirrors React's 100ms focus).
    modal.addEventListener('dialog:open', function () {
      window.setTimeout(function () { if (input) input.focus(); }, 120);
    });

    // Reset everything when the dialog closes so reopening is clean.
    modal.addEventListener('dialog:close', function () { reset(); });
  })();
  } catch(e) { console.error(e); }
})();

})();
